import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import style from './progress-bar.module.less';

export const ProgressBar = ({
  theme = 'primary',
  indefiniteProgress = false,
  percentageComplete = 0,
  className,
  renderWithWrapper = true,
  wrapperClassName,
}) => {
  const classNames = {
    [style['progress-bar-wrapper']]: renderWithWrapper,
    [style['indefinite-progress-bar']]: indefiniteProgress,
  };
  const progressBarStyle = {
    width: indefiniteProgress ? undefined : `${percentageComplete}%`,
  };

  return (
    <div className={classnames(classNames, wrapperClassName)}>
      <div className={classnames(style['progress-bar'], style[`theme-${theme}`], className)} style={progressBarStyle} />
    </div>
  );
};

ProgressBar.propTypes = {
  theme: PropTypes.oneOf(['primary', 'create', 'danger', 'warning']),
  indefiniteProgress: PropTypes.bool,
  percentageComplete: PropTypes.number,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
};
